<lib-prod-grid
  [title]="prodGridTitle"
  [icon]="'dataset'"
  [columns]="prodGridColumns"
  [isAddButtonShown]="true"
  [isAddButtonDisabled]="isAddButtonDisabled"
  [isEditButtonShown]="isEditButtonShown"
  [matTableDataSource]="matTableDataSource"
  [inputAction$]="inputAction$"
  (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
